// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e665439","239":"44ea37e2","453":"fff26968","553":"d055c878"}[chunkId] + ".chunk.js";
};